import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { WrappedButton } from '../button';
import { WrappedButtonType } from '../button/WrappedButtonType.enum';

// This component renders a grid of buttons using PrimeReact's FlexGrid model

const renderButtons = buttons =>
	buttons.map((btn, i) => {
		const {
			label,
			icon,
			iconPos,
			className,
			onClick,
			disabled,
			colWidth,
			smWidth,
			mdWidth,
			lgWidth,
			dataqa,
		} = btn;

		const gridClassName = classNames(
			`p-col${colWidth ? `-${colWidth}` : ''}`,
			`p-sm${smWidth ? `-${smWidth}` : ''}`,
			`p-md${mdWidth ? `-${mdWidth}` : ''}`,
			`p-lg${lgWidth ? `-${lgWidth}` : ''}`
		);
		return (
			<div key={i + (label || 'common')} className={gridClassName}>
				<WrappedButton
					label={label}
					icon={icon}
					iconPos={iconPos}
					className={className || 'grid-item-container'}
					onClick={onClick}
					disabled={disabled}
					dataqa={dataqa || 'common-buttongrid-btn'}
					buttonType={WrappedButtonType.TertiaryGrey}
				/>
			</div>
		);
	});

export const ButtonGrid = ({ buttons = [], dataqa = 'common' }) => (
	<div
		className="common-ui-buttongrid"
		data-qa={`ui-buttongrid-${dataqa}`}
		{...{ dataqa: `ui-buttongrid-${dataqa}` }}
	>
		<div className="p-grid">{renderButtons(buttons)}</div>
	</div>
);

ButtonGrid.propTypes = {
	buttons: PropTypes.arrayOf(
		PropTypes.shape({
			...WrappedButton.propTypes,

			// specify column width for PrimeReact FlexGrid - default/no value falls back to auto-width columns
			colWidth: PropTypes.number,
			smWidth: PropTypes.number,
			mdWidth: PropTypes.number,
			lgWidth: PropTypes.number,
		})
	),
	dataqa: PropTypes.string,
};
